export const finishStyles = {
  container: 'flex flex-col gap-8 px-2 py-4',
  detailContainer: 'space-y-4',
  description: 'text-sm font-bold text-gray-900 text-xl',
  question: 'mt-2 text-center text-base font-medium text-gray-800',
  // Sempre lado a lado; usa wrap se viewport ficar muito estreita
  buttonsWrapper: ' mt-auto flex flex-col gap-4 pt-2 md:flex-row md:gap-6',
  buttonGrow: 'flex-1',
  confirmButton:
    'h-14 w-full rounded-lg bg-black text-base font-semibold text-white transition-colors hover:bg-gray-900 disabled:opacity-60 disabled:cursor-not-allowed',
  cancelButton:
    'h-14 w-full rounded-lg text-base font-medium border border-primary-pure text-primary-pure hover:bg-stone-100',
  emptyBox:
    'rounded-lg border border-gray-200 bg-white p-6 text-center text-sm text-gray-600',
  loadingText: 'text-center text-sm text-gray-500',

  // Cards para mobile
  card: 'bg-white rounded-xl border border-gray-200 shadow-sm hover:shadow-md transition-all duration-200 overflow-hidden',
  cardHeader:
    'bg-gradient-to-r from-blue-50 to-indigo-50 px-4 py-3 border-b border-gray-100',
  cardDate: 'text-sm font-semibold text-gray-900',
  cardDateLabel: 'text-xl font-semibold text-gray-900',
  cardBody: 'p-4',
  cardRow: 'flex justify-between items-center py-2',
  cardLabel: 'text-sm font-medium text-gray-600',
  cardStatus:
    'inline-flex items-center px-2.5 py-1 rounded-full text-xs font-medium',
  cardRoute: 'text-sm font-semibold text-gray-900',

  // Status do card
  cardStatusClosed: 'bg-green-100 text-green-800',
  cardStatusOpen: 'bg-yellow-100 text-yellow-800',
  cardStatusCancelled: 'bg-red-100 text-red-800',
  cardStatusAll: 'bg-purple-100 text-purple-800',
  cardAmount: 'text-lg font-bold text-green-600',

  // Skeleton
  skeletonWrapper: 'animate-pulse space-y-3',
  skeletonLineSm: 'h-3 bg-gray-200 rounded w-24',
  skeletonLineMd: 'h-4 bg-gray-200 rounded w-40',
  skeletonLineLg: 'h-5 bg-gray-200 rounded w-56',
  skeletonBadge: 'h-5 w-20 bg-gray-200 rounded-full',
} as const

// Estilos específicos para a tela de Jornada Concluída
export const concludedStyles = {
  container: 'mx-auto flex w-[90%] max-w-2xl flex-col gap-6 pt-3',
  card: 'flex flex-col gap-4 rounded-lg bg-white p-6 shadow',
  cardInfoWrapper: 'flex flex-col gap-1 text-sm text-gray-600',
  cardInfoMuted: 'text-sm text-gray-500',
  buttonsWrapper:
    'flex flex-col items-center justify-center gap-4 pt-4 sm:flex-row sm:justify-center',
  printButton:
    'flex h-14 w-full max-w-xs items-center justify-center rounded-xl bg-blue-600 px-8 text-base font-semibold text-white shadow-md transition-colors duration-150 hover:bg-blue-700 hover:shadow-lg sm:w-48',
  finishButton:
    'flex h-14 w-full max-w-xs items-center justify-center rounded-xl bg-black px-8 text-base font-semibold text-white shadow-md transition-colors duration-150 hover:bg-gray-900 hover:shadow-lg sm:w-48',
  icon: 'mr-2 h-5 w-5',
} as const

export const finishTexts = {
  title: 'Cierre de Jornada',
  resume: 'Resumen',
  totalLabel: 'Total',
  routeLabel: 'Ruta',
  dateLabel: 'Fecha',
  question: '¿Desea cerrar jornada?',
  confirm: 'Sí',
  abort: 'No',
  noJourney: 'No hay jornada activa.',
  loading: 'Cargando...',
  actualStatus: 'Estado actual',
  amount: 'Monto',

  // Status
  statusClosed: 'Cerrada',
  statusOpen: 'Abierta',
  statusCancelled: 'Cancelada',
  statusInProgress: 'En Progreso',
  statusAll: 'Todos',
} as const

// Textos específicos da tela de Jornada Concluída
export const concludedTexts = {
  title: 'Jornada concluida',
  description: 'La jornada ha sido cerrada exitosamente.',
  print: 'Imprimir',
  finish: 'Finalizar',
  noJourney: 'No existe una jornada activa.',
} as const
